import { render, staticRenderFns } from "./ImportSetupStep.vue?vue&type=template&id=7319dfea&scoped=true&"
import script from "./ImportSetupStep.vue?vue&type=script&lang=js&"
export * from "./ImportSetupStep.vue?vue&type=script&lang=js&"
import style0 from "./ImportSetupStep.vue?vue&type=style&index=0&id=7319dfea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7319dfea",
  null
  
)

export default component.exports